import { computed } from 'mobx';
import { find } from 'lodash';

import Invitation from './invitation';
import OrgRole from './role';
import { Role } from 'auth';
import Staff from './staff';
import { type } from '../core/serialization';

export default class Organization {
  id: number = null;
  uuid: string = null;
  name: string = null;
  country: string = null;
  zipCode: string = null;
  timezone: string = null;
  sport: string = null;
  businessType: string = null;
  plan: string = null;
  numberOfTeamsPaidFor: number = null;
  registrationType: string = null;
  paymentProvider: string = null;
  notes: string = null;
  mailingAddress: string = null;
  mailingAddress2: string = null;
  mailingCity: string = null;
  mailingState: string = null;
  mailingZip: string = null;
  mailingCountry: string = null;
  playerCount: number = 0;
  disabled: boolean = false;
  disabledMessageType: string = null;
  disabledMessageTemplate: string = null;
  isTest: boolean = false;
  tournamentOrgId: number = null;
  currency?: string = null;
  currencySymbol?: string = null;
  websiteUrl?: string = null;
  @type(Staff) staff: Staff[] = [];
  @type(Invitation) invitations: Invitation[] = [];
  @type(OrgRole) roles: Role[] = [];

  @computed
  get ownerInvite() {
    return find(this.invitations, (i) => i && i.role === Role.Owner);
  }
}
